import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/faq',
            meta: {
                showNavbar: false
            },
            component: { render: () => h(RouterView) },
            children: [
                {
                    path: '',
                    name: 'faq',
                    meta: {
                        showNavbar: false
                    },
                    component: () => import("./faq.vue")
                },
            ]
        }
    ];
};